import React from "react";

import { faEllipsisH } from "@fortawesome/pro-solid-svg-icons/faEllipsisH";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Dropdown from "antd/es/dropdown";
import { ItemType } from "antd/es/menu/hooks/useItems";
import Tooltip from "antd/es/tooltip";
import { useIntl } from "react-intl";

import { Button } from "@mapmycustomers/ui";

import styles from "./EllipsisMenu.module.scss";

interface Props {
  items: ItemType[];
}

const EllipsisMenu: React.FC<Props> = ({ items }) => {
  const intl = useIntl();

  return (
    <Dropdown menu={{ className: styles.dropdown, items }} trigger={["click"]}>
      <Tooltip
        title={intl.formatMessage({
          id: "dashboard.header.ellipsisMenu.openMenu",
          defaultMessage: "Open menu",
          description: "Tooltip for open menu button",
        })}
      >
        <Button icon={<FontAwesomeIcon icon={faEllipsisH} size="lg" />} type="control" />
      </Tooltip>
    </Dropdown>
  );
};

export default EllipsisMenu;
